<template>
  <main class="d-flex flex-column justify-content-center">
    <section class="d-flex flex-row justify-content-center">
      <div class="align-self-center">
        <fingerprint-spinner
            :animation-duration="1000"
            :size="100"
            color="var(--color-sixth, rgba(102, 102, 51, 1))"/>
        <div class="d-flex flex-row mt-3">
          <div class="text-loading">Chargement</div>
          <div class="dotIcon">
            <hollow-dots-spinner
                :animation-duration="1000"
                :dot-size="5"
                :dots-num="3"
                color="var(--color-sixth, rgba(102, 102, 51, 1))"/>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import {FingerprintSpinner, HollowDotsSpinner} from 'epic-spinners'

export default {
  name: "Spinner",
  props: {},
  data(){
    return{}
  },
  components: {
    FingerprintSpinner,
    HollowDotsSpinner,

  },
  methods: {
    ...mapMutations([]),
    ...mapActions([]),
  },
  computed: {
    ...mapGetters([])
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {}

}
</script>

<style lang="scss" scoped>
.text-loading{
  color: var(--color-sixth, rgba(102, 102, 51, 1));
  font-weight: bold;
}
.dotIcon{
  margin-top: .8rem;
}
main {
  width: 100%;
  //height: 100%;
  min-height: 70vh;
  & > section{
    width: 350px;
    height: 250px;
    margin: 0 auto;
    //background: transparent;
    background: var(--color-first-0-8);
    border-radius: 15px;
    //border: 1px solid var(--color-seventeenth, rgba(34, 134, 195, 1));
  }
}

@media (min-width: 576px) {}

@media (min-width: 768px) {}

@media (min-width: 992px) {}

@media (min-width: 1200px) {}
</style>



// WEBPACK FOOTER //
// src/components/shared/Spinner.vue